export default __webpack_public_path__ + "static/media/marker-gray-orange.07b5875b.png";